module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_names-23185052c9399b9f75267f53124bec71.gif";